import { create } from 'zustand';

// Shared state between the BrandingReminderDialog (which runs the checks) and
// the Topbar (which shows a small "checking…" spinner over the user avatar).
// Intentionally not persisted — the checks should re-run on every workspace
// switch / login.

interface BrandingReminderState {
  checking: boolean;
  setChecking: (value: boolean) => void;
}

export const useBrandingReminderStore = create<BrandingReminderState>((set) => ({
  checking: false,
  setChecking: (value) => set({ checking: value }),
}));
